import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SurCreditMemoModel } from "@tSurya/Services/CreditMemoService";
import { CreditDataState } from "@tSurya/Store/Data/SurCreditDataState";
import { Draft } from "immer";

const initialState: CreditDataState = {
    isLoading: false,
    creditdata: [],
    searchparameter: [],
    pagination: null,
};
const creditMemoReducer = {
    "Custom/CreditMemoData/BeginLoadCreditMemo": (draft: Draft<CreditDataState>) => {
        draft.isLoading = true;
    },
    "Custom/CreditMemoStore/CompletedLoadCreditMemoStore": (
        draft: Draft<CreditDataState>,
        action: { searchparameter: SurCreditMemoModel },
    ) => {
        draft.searchparameter = action.searchparameter;
        draft.isLoading = true;
    },
    "Custom/CreditMemo/CompletedLoadCreditMemo": (
        draft: Draft<CreditDataState>,
        action: {
            result: SurCreditMemoModel;
        },
    ) => {
        draft.creditdata = action.result;
        draft.pagination = action.result.pagination;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, creditMemoReducer);
